import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Styled Elements
import { TableButtonWrapper, TableRowWrapper, Title, ColWrapper } from './ApiKeysTableHeader.elements'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions
function ApiKeysTableHeader() {
  return (
    <TableButtonWrapper>
      <TableRowWrapper>
        <ColWrapper>
          <Title>LABEL</Title>
        </ColWrapper>
        <ColWrapper>
          <Title>ALLOWED IPs</Title>
        </ColWrapper>
        <ColWrapper>
          <Title>CREATED</Title>
        </ColWrapper>
        <ColWrapper>
          <Title>EXPIRES</Title>
        </ColWrapper>
        <ColWrapper />
      </TableRowWrapper>
    </TableButtonWrapper>
  )
}

// Default Props
ApiKeysTableHeader.defaultProps = {
  actions: {},
  data: {},
}

// Proptypes Validation
ApiKeysTableHeader.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    created: PropTypes.string,
    expires: PropTypes.string,
  }),
  actions: PropTypes.shape({
    setApiKeyToDelete: PropTypes.func,
    toggleRemoveApiKeyModal: PropTypes.func,
    showAlert: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(ApiKeysTableHeader)
